const mutations = {
  getServicesMicrosite: (state, service_id) => {
    state.service_id = service_id;
  },
};

export default mutations;
